import "./Skills.css";

function Skills() {
  return (
    <div className="skills-cont">
      <div className="skills-content">
        <ul className="skills-list">
          <li className="skills-listItem-head">Skills:</li>
          <li className="skills-listItem">
            <span>HTML</span>
          </li>
          <li className="skills-listItem">
            <span>CSS</span>
          </li>
          <li className="skills-listItem">
            <span>JavaScript</span>
          </li>
          <li className="skills-listItem">
            <span>React</span>
          </li>
          <li className="skills-listItem">
            <span>TypeScript</span>
          </li>
          <li className="skills-listItem">
            <span>jQuery</span>
          </li>
          <li className="skills-listItem">
            <span>Github</span>
          </li>
          <li className="skills-listItem">
            <span>PHP</span>
          </li>
          <li className="skills-listItem">
            <span>C#</span>
          </li>
          <li className="skills-listItem">
            <span>MySQL</span>
          </li>
        </ul>
      </div>
      <div className="copyright">
        © 2025 | <a href="https://onvlpk.csb.app/">Elizabeth Adegunwa</a>
      </div>
    </div>
  );
}

export default Skills;
